import HCLTreeVertex from '../HCLTreeVertex';
import ReferenceTypes from "../HCLTreeVertexValue/ReferenceTypes";

abstract class EventTreeVertex extends HCLTreeVertex {

  private refType: ReferenceTypes = null;

  /**
   * @return {string}
   */
  public getReferenceType(): ReferenceTypes {
    return this.refType;
  }



}

export default EventTreeVertex;
